export const getElement = ({
  content,
  zIndex = 200,
}: {
  content: string
  zIndex?: number
}) => {
  const element = document.createElement('div')
  element.style.position = 'absolute'
  element.style.transform = 'translate(-50%, -50%)'
  element.style.userSelect = 'none'
  element.style.zIndex = zIndex.toString()
  element.classList.add('overlay-container')
  element.innerHTML = content

  return element
}
